<template>
  <ConfirmationModal
    ref="change-notification-mode-confirmation"
    :onCancelHandler="onCancelHandler"
    :onConfirmHandler="onConfirmHandler"
  >
    <template #content>
      <div
        class="alert alert-warning"
        role="alert"
      >
        <h6>
          <i class="bi bi-exclamation-triangle" />
          Do You really want to change the {{ serviceType }} notification status? It will affect all the users of
          {{ serviceTarget }}.
        </h6>
      </div>
    </template>
  </ConfirmationModal>
</template>
<script>
import ConfirmationModal from '@/components/common/ConfirmationModal';
export default {
  components: {
    ConfirmationModal,
  },
  props: [ 'onCancelHandler', 'onConfirmHandler', 'serviceName' ],
  data() {
    return {
      confirmationModal: null,
      savedServiceName: null,
    };
  },
  computed: {
    serviceType() {
      const name = this.savedServiceName || this.serviceName;
      if (!name) {
        return 'customer portal';
      }
      return name.startsWith('admin-panel') ? 'admin panel' : 'customer portal';
    },
    serviceTarget() {
      const name = this.savedServiceName || this.serviceName;
      if (!name) {
        return 'Outerspace Customer Portal';
      }
      return name.startsWith('admin-panel') ? 'Outerspace Admin Panel' : 'Outerspace Customer Portal';
    },
  },
  watch: {
    serviceName(newVal) {
      if (newVal) {
        this.savedServiceName = newVal;
      }
    },
  },
  mounted() {
    this.confirmationModal = this.$refs['change-notification-mode-confirmation'].confirmationModal;
  },
};
</script>
